import { Box, Rating, Slider, Stack, Typography } from '@mui/material'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'
import InputCustom from '../../components/atoms/input/InputCustom'
import BreadcrumbCustom from '../../components/atoms/breadcrumb/BreadcrumbCustom'
import { Link } from 'react-router-dom'
import SwitchBtn from '../../components/atoms/switch-btn/SwicthBtn'
import Stepper from '../../components/atoms/Stepper/Stepper'
import StatusBtn from '../../components/atoms/status/StatusBtn'
import DropdownButton from '../../components/atoms/dropdown/Dropdown'
import CheckBoxCustom from '../../components/atoms/checkbox/CheckBox'
import { useState } from 'react'
import CommonModal from '../../components/atoms/modal/CommonModal'
import SelectCustom from '../../components/atoms/select/SelectCustom'
import CustomUserSearch from '../../components/atoms/CustomUserSearch'
import DropdownMenu from '../../components/atoms/dropdown-menu/DropdownMenu'
import TableDataGrid from '../../components/atoms/table/TableDataGrid'
import MultiselectSearch from '../../components/atoms/select/MultiSelect'
import TextArea from '../../components/atoms/textarea/TextArea'
import FileAttach from '../../components/atoms/file-attach/FileAttach'
import BrideImage from '../../components/atoms/BrideImage/BrideImage'
import Venues from '../../components/atoms/Venues/Venues'
import CategoryTree from '../../components/atoms/CategoryTree/CategoryTree'
import Response from '../../components/atoms/Response/Response'
import ProposalCard from '../../components/atoms/ProposalCard/ProposalCard'
import WelComeCard from '../../components/atoms/DashBordCards/WelComeCard'
import CurateCard from '../../components/atoms/DashBordCards/CurateCard'
import PartyCards from '../../components/atoms/DashBordCards/PartyCards'
import PriceRange from '../../components/atoms/price-range/PriceRange'
import VendorCardGrid from '../../components/atoms/vendor-card/VendorCardGrid'
import VendorCardList from '../../components/atoms/vendor-card/VendorCardList'
import TabCustom from '../../components/atoms/tab/TabCustom'
import SearchField from '../../components/atoms/search-field/SearchField'
import RecommendedVendorsCard from '../../components/UserDashboard/RecommendedVendors/RecommendedVendorsCard'
import RecommendedVenuesCard from '../../components/UserDashboard/RecommendedVenues/RecommendedVenuesCard'
import VenuesSelectionCard from '../../components/UserDashboard/VenuesSelectionCard/VenuesSelectionCard'

import DateCustom from '../../components/atoms/input/DateCustom'
import PaymentLines from '../../components/atoms/PaymentLines/PaymentLines'

import { PieChart } from '@mui/x-charts/PieChart'
import BudgetCard from '../../components/atoms/budget-card/BudgetCard'
import { LineChart } from '@mui/x-charts'
import WeddingCard from '../../components/atoms/wedding-card/WeddingCard'
import InvoiceTemplate from '../../components/atoms/InvoiceTemplate/InvoiceTemplate'
import UploadLogo from '../../components/atoms/UploadLogo/UploadLogo'
import InvoicePreview from '../../components/atoms/InvoicePreview/InvoicePreview'
import TimeCustom from '../../components/atoms/input/TimeCustom'

// const images = [{ src: '/images/CuratedList.jpg', title: 'Fairytale' }]

const lineChartPData = [1200, 1800, 2100, 1900, 2500, 3000] // Spending values
const lineChartXLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'] // Months
const data = [
	{ value: 25, label: 'Venue', color: '#34464F' }, // dark gray-blue
	{ value: 15, label: 'Photography', color: '#587686' }, // teal
	{ value: 20, label: 'Food', color: '#7CA6BD' }, // light blue
	{ value: 30, label: 'Entertainment', color: '#A7C3D3' }, // pale blue
	{ value: 10, label: 'Decor', color: '#D6E3EB' }, // very light blue
]

const size = {
	width: 300,
	height: 250,
}
const images = [
	{ src: '/images/CuratedList.jpg', title: 'Fairytale' },
	{ src: '/images/CuratedList.jpg', title: 'Fairytale' },
	{ src: '/images/CuratedList.jpg', title: 'Fairytale' },
]

export const AtomsPage = () => {
	const handleSwitchChange = (e) => {
		console.log('Switch is now:', e.target.checked ? 'ON' : 'OFF')
	}
	const [open, setOpen] = useState(false)
	const handleOpen = () => setOpen(true)
	const handleClose = () => setOpen(false)
	const [members] = useState([
		{ id: 1, name: 'Alice', avatar: 'https://i.pravatar.cc/150?img=1' },
		{ id: 2, name: 'Sophia', avatar: 'https://i.pravatar.cc/150?img=2' },
	])
	const [selected, setSelected] = useState([
		{ id: 3, name: 'Mia', avatar: 'https://i.pravatar.cc/150?img=3' },
		{ id: 4, name: 'Emma', avatar: 'https://i.pravatar.cc/150?img=4' },
	])

	const options = [
		{ value: 'oliver hansen', label: 'Oliver Hansen' },
		{ value: 'van henry', label: 'Van Henry' },
		{ value: 'april tucker', label: 'April Tucker' },
		{ value: 'ralph hubbard', label: 'Ralph Hubbard' },
		{ value: 'omar alexander', label: 'Omar Alexander' },
	]

	const dropdownMenuOptions = [
		{ label: 'Edit', icon: <img src="/images/assign-task.svg" alt="" /> },
		{ label: 'Delete', icon: <img src="/images/DeleteModal.svg" alt="" /> },
		{
			label: 'Duplicate',
			icon: <img src="/images/edit-icon.svg" alt="" />,
		},
	]

	const handleSelect = (member) => {
		setSelected((prev) => [...prev, member])
	}

	const handleRemove = (id) => {
		setSelected((prev) => prev.filter((m) => m.id !== id))
	}

	const [selectedMembers, setSelectedMembers] = useState([])
	const handleMultiSelect = (member) => {
		setSelectedMembers((prev) => [...prev, member])
	}

	const handleMultiRemove = (memberId) => {
		setSelectedMembers((prev) =>
			prev.filter((member) => member._id !== memberId)
		)
	}
	const membersNames = [
		{
			_id: 1,
			name: 'Kathryn Murphy',
			avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612c36f?w=150&h=150&fit=crop&crop=face',
		},
		{
			_id: 2,
			name: 'Annette Black',
			avatar: 'https://images.unsplash.com/photo-1527980965255-d3b416303d12?w=150&h=150&fit=crop&crop=face',
		},
		{
			_id: 3,
			name: 'Dianne Russell',
			avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
		},
		{
			_id: 4,
			name: 'Ronald Richards',
			avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
		},
		{
			_id: 5,
			name: 'Jerome Bell',
			avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
		},
	]

	const [text, setText] = useState('')

	const [userDetails, setUserDetails] = useState({
		lowerPriceRange: 1000,
		upperPriceRange: 5000,
		maxCapacity: 150,
	})

	const vendorCardData = {
		id: 1,
		category: 'Events and Decor',
		vendorName: 'Celestial Events',
		location: '1901 Thornridge Shiloh, Hawaii 81063',
		image: '/images/vendor-card-img.png',
		label: true,
	}
	const vendorCardListData = {
		id: 1,
		category: 'Events and Decor',
		vendorName: 'Celestial Events',
		location: '1901 Thornridge Shiloh, Hawaii 81063',
		image: '/images/ontimebride_iconset_blue_vendor_default.png',
		label: true,
	}

	const tabData = [
		{
			id: 1,
			tabIcon: (
				<svg
					width="16"
					height="16"
					viewBox="0 0 16 16"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M13.2663 9H2.73301C1.73301 9 1.33301 9.42667 1.33301 10.4867V13.18C1.33301 14.24 1.73301 14.6667 2.73301 14.6667H13.2663C14.2663 14.6667 14.6663 14.24 14.6663 13.18V10.4867C14.6663 9.42667 14.2663 9 13.2663 9Z"
						stroke="#8692A4"
						stroke-width="1.33"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M13.2663 1.33398H2.73301C1.73301 1.33398 1.33301 1.76065 1.33301 2.82065V5.51398C1.33301 6.57398 1.73301 7.00065 2.73301 7.00065H13.2663C14.2663 7.00065 14.6663 6.57398 14.6663 5.51398V2.82065C14.6663 1.76065 14.2663 1.33398 13.2663 1.33398Z"
						stroke="#8692A4"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
			),
			tabLabel: 'List',
		},
		{
			id: 2,
			tabIcon: (
				<svg
					width="16"
					height="16"
					viewBox="0 0 16 16"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M14.6667 5.68065V2.65398C14.6667 1.71398 14.24 1.33398 13.18 1.33398H10.4867C9.42667 1.33398 9 1.71398 9 2.65398V5.67398C9 6.62065 9.42667 6.99398 10.4867 6.99398H13.18C14.24 7.00065 14.6667 6.62065 14.6667 5.68065Z"
						stroke="#8692A4"
						stroke-width="1.33"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M14.6667 13.18V10.4867C14.6667 9.42667 14.24 9 13.18 9H10.4867C9.42667 9 9 9.42667 9 10.4867V13.18C9 14.24 9.42667 14.6667 10.4867 14.6667H13.18C14.24 14.6667 14.6667 14.24 14.6667 13.18Z"
						stroke="#8692A4"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M6.99967 5.68065V2.65398C6.99967 1.71398 6.57301 1.33398 5.51301 1.33398H2.81967C1.75967 1.33398 1.33301 1.71398 1.33301 2.65398V5.67398C1.33301 6.62065 1.75967 6.99398 2.81967 6.99398H5.51301C6.57301 7.00065 6.99967 6.62065 6.99967 5.68065Z"
						stroke="#8692A4"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M6.99967 13.18V10.4867C6.99967 9.42667 6.57301 9 5.51301 9H2.81967C1.75967 9 1.33301 9.42667 1.33301 10.4867V13.18C1.33301 14.24 1.75967 14.6667 2.81967 14.6667H5.51301C6.57301 14.6667 6.99967 14.24 6.99967 13.18Z"
						stroke="#8692A4"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
			),
			tabLabel: 'Grid',
		},
	]
	const [innerTab, setInnerTab] = useState(0)
	const handleInnerTab = (e, tab) => {
		setInnerTab(tab)
	}
	const [search, setSearch] = useState('')

	const [selectedIndices, setSelectedIndices] = useState([])
	const toggleSelect = (index) => {
		setSelectedIndices(
			(prev) =>
				prev.includes(index)
					? prev.filter((i) => i !== index) // remove if already selected
					: [...prev, index] // add if not selected
		)
	}

	const PaymentData = [
		{
			data: 'Requested on',
			itemData: '2025-08-20',
		},
		{
			data: 'Invoice',
			itemData: 'INV-2001',
		},
		{
			data: 'Payment',
			itemData: 'P-1001',
		},
	]

	const templates = [
		{
			id: 1,
			image: '/images/InvoiceTemplate01.svg',
			title: 'Standard',
			description: 'A simple, professional invoice template',
		},
		{
			id: 2,
			image: '/images/InvoiceTemplate02.svg',
			title: 'Modern',
			description: 'A clean, contemporary design',
		},
		{
			id: 3,
			image: '/images/InvoiceTemplate03.svg',
			title: 'Classic',
			description: 'Traditional invoice layout',
		},
	]

	const [selectedId, setSelectedId] = useState(1)

	return (
		<div className="container" style={{ width: '100%', padding: '1rem' }}>
			<h1 style={{ textAlign: 'left' }}>New Atoms</h1>
			<br />
			<InvoicePreview />
			<br />
			<UploadLogo onChange={(e) => console.log(e.target.files[0])} />
			<br />
			<div
				style={{
					display: 'grid',
					gridTemplateColumns: 'repeat(3, 1fr)',
				}}
			>
				{templates.map((template) => (
					<InvoiceTemplate
						key={template.id}
						image={template.image}
						title={template.title}
						description={template.description}
						selected={selectedId === template.id}
						onSelect={() => setSelectedId(template.id)}
					/>
				))}
			</div>
			<br />
			<PaymentLines PaymentData={PaymentData} />
			<br />
			<div style={{ margin: '1rem 0' }}>
				<InputCustom type="date" name="date" />
				<br />
				<DateCustom
					name="date"
					setDataFunction={setUserDetails}
					data={userDetails}
					value={userDetails.date}
				/>
			</div>
			<br />
			<div style={{ margin: '1rem 0' }}>
				<Box sx={{ '& > legend': { mt: 2 } }}>
					<Rating
						name="customized-10"
						defaultValue={4}
						max={5}
						icon={
							<img
								src="/images/star.svg"
								alt="filled icon"
								style={{
									width: '23px',
									height: '23px',
								}}
							/>
						}
						emptyIcon={
							<img
								src="/images/star-without-fill.svg"
								alt="empty icon"
								style={{
									width: '23px',
									height: '23px',
								}}
							/>
						}
					/>
				</Box>
			</div>
			<div className="" style={{ display: 'flex', gap: '1rem' }}>
				{images.map((item, index) => (
					<VenuesSelectionCard
						key={index}
						image={item.src}
						title={item.title}
						selected={selectedIndices.includes(index)}
						onClick={() => toggleSelect(index)}
					/>
				))}
			</div>
			<br />
			<div className="">
				<RecommendedVendorsCard
					imageSrc="/images/RecommendedVendors.png"
					imageAlt="RecommendedVendors"
					title="Caviar on Foot"
					description="Description"
				/>
				<br />
				<RecommendedVendorsCard
					imageSrc="/images/RecommendedVendors.png"
					imageAlt="RecommendedVendors"
					title="Caviar on Foot"
					description="Description"
				/>
				<br />
				<RecommendedVenuesCard
					image="/images/CuratedList.jpg"
					title="Recommended Venues"
					location="Bandra, Mumbai"
					hours="10 AM - 11 PM"
					capacity={250}
					tags={['Outdoor', 'Stage']}
					onDetailsClick={() => console.log('Details clicked')}
				/>
			</div>
			<br />
			<div className="">
				<PartyCards
					partyMembers={[
						{ id: 1, name: 'Jessy', image: '/images/WelCome.png' },
						{ id: 2, name: 'Groom', image: '/images/WelCome.png' },
						{
							id: 3,
							name: 'Bride’s Mother',
							image: '/images/WelCome.png',
						},
					]}
					onAddOthersClick={() => alert('Add others clicked')}
				/>
			</div>
			<br />
			<div style={{ display: 'flex', gap: '2rem' }}>
				<div style={{ flex: 1 }}>
					<CurateCard />
				</div>
				<div style={{ flex: 1 }}>
					<WelComeCard
						text="Jessy"
						image="/images/WelCome.png"
						image2="/images/WelCome.png"
						alt1="Jessy"
						alt2="Jessy"
					/>
				</div>
			</div>

			<br />
			<div
				className=""
				style={{
					display: 'grid',
					gridTemplateColumns: 'repeat(3, 1fr)',
					gap: '1rem',
				}}
			>
				<ProposalCard
					ViewDetail={false}
					image="/images/bride2.png"
					responseLabel="Unresponsive"
					StatusLabel="Submitted"
				/>
				<ProposalCard
					ViewDetail={false}
					image="/images/bride1.png"
					StatusLabel="Approved"
					responseLabel="Responsive"
					title="Michael & Sara"
					date="12 Aug 2024"
					guests="150 Guests"
					service="Catering"
					description="Full buffet + 3 chefs"
					price="$120,000"
				/>
				<ProposalCard
					ViewDetail={false}
					image="/images/bride2.png"
					StatusLabel="In Review"
					responseLabel="Neutral"
					title="Michael & Sara"
					date="12 Aug 2024"
					guests="150 Guests"
					service="Catering"
					description="Full buffet + 3 chefs"
					price="$120,000"
				/>
				<ProposalCard
					ViewDetail={false}
					image="/images/bride1.png"
					StatusLabel="Declined"
					responseLabel="Less Responsive"
					title="Michael & Sara"
					date="12 Aug 2024"
					guests="150 Guests"
					service="Catering"
					description="Full buffet + 3 chefs"
					price="$120,000"
				/>
				<ProposalCard image="/images/bride2.png" />
			</div>
			<br />

			<div className="">
				<BrideImage
					srcOne="/images/bride1.png"
					srcTwo="/images/bride2.png"
				/>
			</div>
			<br />
			<div className="">
				<Venues location="The Grand Lawn, Goa" />
			</div>
			<br />
			<div className="">
				<CategoryTree
					title="Photography"
					subTitle={['2 Photographers', '1 Cinematographer']}
				/>
			</div>
			<br />
			<div
				className=""
				style={{
					backgroundColor: 'var(--bg1)',
					padding: '20px',
					display: 'grid',
					gridTemplateColumns: 'repeat(3, 1fr)',
					gap: '1rem',
				}}
			>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '10px',
					}}
				>
					<p>Default size lg</p>
					<Response label="Very Responsive" />
					<Response label="Responsive" />
					<Response label="Neutral" />
					<Response label="Less Responsive" />
					<Response label="Unresponsive" />
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '10px',
					}}
				>
					<p>size md</p>
					<Response size="md" label="Very Responsive" />
					<Response size="md" label="Responsive" />
					<Response size="md" label="Neutral" />
					<Response size="md" label="Less Responsive" />
					<Response size="md" label="Unresponsive" />
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '10px',
					}}
				>
					<p>size sm</p>
					<Response size="sm" label="Very Responsive" />
					<Response size="sm" label="Responsive" />
					<Response size="sm" label="Neutral" />
					<Response size="sm" label="Less Responsive" />
					<Response size="sm" label="Unresponsive" />
				</div>
			</div>

			<hr style={{ margin: '50px 0' }} />
			<h1 style={{ textAlign: 'left' }}>Atoms....</h1>
			<br />

			<div
				style={{
					margin: '10px 0',
				}}
			>
				<SearchField
					searchPlaceholder="Search Vendor"
					searchValue={search}
					onSearchChange={setSearch}
				/>
			</div>
			<div
				style={{
					margin: '10px 0',
				}}
			>
				<TabCustom
					innerTab={innerTab}
					onInnerTabChange={handleInnerTab}
					tabData={tabData}
				/>
				<br />
				{innerTab === 0 ? (
					<h2>Tab one content</h2>
				) : (
					<h2>Tab Two content</h2>
				)}
			</div>
			<div
				style={{
					margin: '10px 0',
				}}
			>
				<PriceRange
					userDetails={userDetails}
					setUserDetails={setUserDetails}
				/>
			</div>
			<VendorCardGrid data={vendorCardData} />
			<br />
			<VendorCardList data={vendorCardListData} />
			<div style={{ margin: '1rem 0', display: 'flex', gap: '1rem' }}>
				<DropdownMenu options={dropdownMenuOptions} />
			</div>

			<div style={{ margin: '1rem 0', display: 'flex', gap: '1rem' }}>
				<FileAttach
					label="Choose File"
					placeholder="No Files Selected"
					accept=".jpg,.png,.pdf"
					multiple
					onChange={(e) => console.log(e.target.files)}
				/>
			</div>
			<div style={{ margin: '1rem 0', display: 'flex', gap: '1rem' }}>
				<TextArea
					placeholder="Write something..."
					value={text}
					onChange={(e) => setText(e.target.value)}
				/>
			</div>
			<div style={{ margin: '1rem 0', display: 'flex', gap: '1rem' }}>
				<MultiselectSearch
					members={membersNames}
					selected={selectedMembers}
					onSelect={handleMultiSelect}
					onRemove={handleMultiRemove}
					label="Assigned to"
					placeholder="Select"
					searchPlaceholder="Search user..."
				/>
			</div>
			<div style={{ margin: '1rem 0', display: 'flex', gap: '1rem' }}>
				<InputCustom type="date" name="date" />
				<DateCustom
					name="date"
					setDataFunction={setUserDetails}
					data={userDetails}
					value={userDetails.date}
				/>
				<TimeCustom
					label="Meeting Time"
					name="meetingTime"
					value={userDetails.meetingTime}
					setDataFunction={setUserDetails}
					data={userDetails}
				/>
			</div>

			<div
				style={{
					padding: '40px 0',
					display: 'grid',
					justifyContent: 'flex-start',
					gap: '40px',
				}}
			>
				<h4>Steps:-----</h4>
				{/* First Stepper */}
				<Stepper totalSteps={3} subSteps={4} activeStep="3" />

				{/* Second Stepper */}
				<Stepper totalSteps={5} subSteps={4} activeStep="3.2" />

				{/* Third Stepper */}
				<Stepper totalSteps={4} subSteps={4} activeStep="2.6" />
			</div>
			<div>
				<h4 style={{ margin: '1rem 0' }}>Default</h4>

				<div
					style={{
						display: 'flex',
						gap: '1rem',
						flexWrap: 'wrap',
						alignItems: 'center',
					}}
				>
					<ButtonCustom
						// variant="default"
						onClick={() => alert('Button Clicked!')}
					>
						default
					</ButtonCustom>
					<ButtonCustom variant="default" size="sm">
						sm size
					</ButtonCustom>

					<ButtonCustom variant="default" size="lg">
						lg size
					</ButtonCustom>
					<ButtonCustom variant="default" size="lg" disabled>
						disabled
					</ButtonCustom>
				</div>

				<div
					style={{
						margin: '1rem 0',
						display: 'flex',
						gap: '1rem',
						flexWrap: 'wrap',
						alignItems: 'center',
					}}
				>
					<DropdownButton
						label="Create"
						options={['One', 'Two']}
						variant="default"
						onSelect={(opt) => console.log('Selected:', opt)}
					/>
					<DropdownButton
						label="Create"
						options={['One', 'Two']}
						variant="default"
						size="sm"
						onSelect={(opt) => console.log('Selected:', opt)}
					/>
					<DropdownButton
						label="Create"
						options={['One', 'Two']}
						variant="default"
						size="lg"
						onSelect={(opt) => console.log('Selected:', opt)}
					/>
					<DropdownButton
						label="Create"
						options={['One', 'Two']}
						variant="default"
						size="lg"
						disabled
						onSelect={(opt) => console.log('Selected:', opt)}
					/>
				</div>
			</div>
			<div>
				<h4 style={{ margin: '1rem 0' }}>Secondary</h4>
				<div
					style={{
						display: 'flex',
						gap: '1rem',
						flexWrap: 'wrap',
						alignItems: 'center',
					}}
				>
					<ButtonCustom
						variant="secondary"
						onClick={() => alert('Button Clicked!')}
					>
						default
					</ButtonCustom>
					<ButtonCustom variant="secondary" size="sm">
						sm size
					</ButtonCustom>

					<ButtonCustom variant="secondary" size="lg">
						lg size
					</ButtonCustom>
					<ButtonCustom variant="secondary" size="lg" disabled>
						disabled
					</ButtonCustom>
				</div>
			</div>
			<div>
				<h4 style={{ margin: '1rem 0' }}>Destructive</h4>
				<div
					style={{
						display: 'flex',
						gap: '1rem',
						flexWrap: 'wrap',
						alignItems: 'center',
					}}
				>
					<ButtonCustom
						variant="destructive"
						onClick={() => alert('Button Clicked!')}
					>
						default
					</ButtonCustom>
					<ButtonCustom variant="destructive" size="sm">
						sm size
					</ButtonCustom>

					<ButtonCustom variant="destructive" size="lg">
						lg size
					</ButtonCustom>
					<ButtonCustom variant="destructive" size="lg" disabled>
						disabled
					</ButtonCustom>
					<ButtonCustom variant="approve" size="sm">
						approve sm size
					</ButtonCustom>
				</div>
			</div>
			<div>
				<h4 style={{ margin: '1rem 0' }}>Outlined</h4>
				<div
					style={{
						display: 'flex',
						gap: '1rem',
						flexWrap: 'wrap',
						alignItems: 'center',
					}}
				>
					<ButtonCustom
						variant="outlined"
						onClick={() => alert('Button Clicked!')}
					>
						default
					</ButtonCustom>
					<ButtonCustom variant="outlined" size="sm">
						sm size
					</ButtonCustom>

					<ButtonCustom variant="outlined" size="lg">
						lg size
					</ButtonCustom>
					<ButtonCustom variant="outlined" size="lg" disabled>
						disabled
					</ButtonCustom>
				</div>
			</div>
			<div>
				<h4 style={{ margin: '1rem 0' }}>Link</h4>
				<div
					style={{
						display: 'flex',
						gap: '1rem',
						flexWrap: 'wrap',
						alignItems: 'center',
					}}
				>
					<ButtonCustom
						variant="link"
						onClick={() => alert('Button Clicked!')}
					>
						default
					</ButtonCustom>
					<ButtonCustom variant="link" size="sm">
						sm size
					</ButtonCustom>

					<ButtonCustom variant="link" size="lg">
						lg size
					</ButtonCustom>
					<ButtonCustom variant="link" size="lg" disabled>
						disabled
					</ButtonCustom>
					<ButtonCustom to={'/'} variant="link" size="lg" disabled>
						Link/anchor tag
					</ButtonCustom>
				</div>
			</div>
			<div
				style={{
					display: 'flex',
					gap: '1rem',
					flexWrap: 'wrap',
					alignItems: 'center',
				}}
			>
				<br />
				<ButtonCustom
					variant="pilled"
					onClick={() => alert('Button Clicked!')}
				>
					Pilled
				</ButtonCustom>

				<ButtonCustom variant="outlined">
					<img src="/images/google-icon.svg" />
					<Typography variant="body">Continue with Google</Typography>
				</ButtonCustom>
			</div>
			<br />

			<div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
				<InputCustom
					type="text"
					name="username"
					id="username"
					placeholder="Enter your username"
					fullWidth
					error={false}
					onChange={(e) => console.log(e.target.value)}
				/>
				<InputCustom
					type="text"
					name="username"
					id="username"
					placeholder="Enter your username"
					fullWidth
					label={'Username'}
					error={false}
					onChange={(e) => console.log(e.target.value)}
				/>
				<InputCustom
					type="password"
					name="password"
					id="password"
					placeholder="Enter your password"
					fullWidth
					error={true}
					helperText="Password is required"
				/>
				<InputCustom
					placeholder="Password"
					name="password"
					type="password"
					enableShowPassword={true}
					required={true}
					eyeIcon={true}
				/>
				<SelectCustom label="Select user" options={options} />
			</div>

			<div style={{ margin: '1rem 0' }}>
				<BreadcrumbCustom>
					<Link to="/" variant="body1">
						Home
					</Link>
					<Link to="/" variant="body1">
						about
					</Link>
					<Link to="/" variant="body1">
						contact
					</Link>
				</BreadcrumbCustom>
			</div>
			<div style={{ margin: '1rem 0' }}>
				<SwitchBtn onClick={handleSwitchChange} />
				<SwitchBtn
					onClick={handleSwitchChange}
					label="Switch"
					labelColor="#000"
				/>
				<SwitchBtn
					onClick={handleSwitchChange}
					label="Switch"
					size={'lg'}
					labelColor="green"
				/>
			</div>
			<div style={{ margin: '1rem 0', display: 'flex', gap: '1rem' }}>
				<StatusBtn label="Active" variant="active" />
				<StatusBtn label="Pending" variant="pending" />
				<StatusBtn label="in Progress" variant="inprogress" />
				<StatusBtn label="Submitted" variant="submitted" />
				<StatusBtn label="Rejected" variant="error" />
			</div>
			<div style={{ margin: '1rem 0', display: 'flex', gap: '1rem' }}>
				<CheckBoxCustom label="Checkbox" />
			</div>

			<div style={{ margin: '1rem 0', display: 'flex', gap: '1rem' }}>
				<ButtonCustom variant="outlined" onClick={handleOpen}>
					Open modal
				</ButtonCustom>
				<CommonModal
					open={open}
					handleClose={handleClose}
					heading={'Heading'}
					footerContent={
						<>
							<ButtonCustom
								variant="outlined"
								size="lg"
								onClick={handleClose}
							>
								Cancel
							</ButtonCustom>
							<ButtonCustom variant="default" size="lg">
								Save
							</ButtonCustom>
						</>
					}
				>
					<h3>Modal body ....</h3>
				</CommonModal>
			</div>

			<div
				style={{
					margin: '1rem 0',
					border: '2px solid #000000',
					padding: '1rem',
				}}
			>
				<CustomUserSearch
					width="100%"
					label="Add Members"
					members={members}
					selected={selected}
					onSelect={handleSelect}
					onRemove={handleRemove}
				/>
			</div>
			<div
				style={{
					margin: '1rem 0',
				}}
			>
				<TableDataGrid />
			</div>
			<div
				style={{
					margin: '1rem 0',
				}}
			>
				<BudgetCard heading="Budget Allocation">
					<PieChart
						series={[
							{
								data, // now contains color per slice
								innerRadius: 70,
								outerRadius: 100,
							},
						]}
						{...size}
						slotProps={{
							legend: {
								direction: 'row',
								position: {
									vertical: 'bottom',
									horizontal: 'middle',
								},
								padding: { top: 8 },
								sx: {
									mt: 2,
									'&.MuiChartsLegend-root': {
										gap: '15px',
										justifyContent: 'center',
									},
									'& .MuiChartsLegend-mark': {
										width: '8px !important',
										height: '8px !important',
										borderRadius: '50%',
										marginRight: '8px',
									},
									'& .MuiChartsLegend-label': {
										fontSize: '12px',
										fontWeight: '400',
										fontFamily: 'Inter',
										color: '#8692A4',
									},
									'& .MuiChartsLegend-series': {
										margin: '0',
										display: 'flex',
										gap: '0',
										alignItems: 'center',
									},
								},
							},
						}}
					/>
				</BudgetCard>
			</div>
			<div
				style={{
					margin: '1rem 0',
				}}
			>
				<BudgetCard heading="Spending Forecast">
					<Box sx={{ width: '100%', height: 175 }}>
						<Box
							sx={{
								width: '100%',
								height: 200,
							}}
						>
							<LineChart
								series={[
									{
										data: lineChartPData,
										label: '', // Required (even if hidden later)
										color: '#7CA6BD',
										boxShadow: '0px 6px 9px 0px #7CA6BD66',
										showMark: true,
										curve: 'natural',
									},
								]}
								xAxis={[
									{
										scaleType: 'point',
										data: lineChartXLabels,
										tickLabelStyle: {
											fill: '#8692A4',
											fontSize: 12,
											fontWeight: 400,
											fontFamily: 'Inter',
										},
									},
								]}
								yAxis={[
									{
										tickLabelStyle: {
											fill: '#8692A4',
											fontSize: 12,
											fontWeight: 400,
											fontFamily: 'Inter',
										},
									},
								]}
								slotProps={{
									legend: {
										hidden: true,
									},
									series: {
										label: {
											hidden: true,
										},
									},
								}}
								sx={{
									'.MuiChartsLegend-root, .MuiChartsLegend-mark, .MuiChartsLegend-series':
										{
											display: 'none !important',
										},

									'.MuiChartsAxis-line': {
										stroke: '#8692A4',
										strokeWidth: 1,
									},

									'.MuiChartsGrid-line': {
										stroke: '#8692A4',
										strokeWidth: 0.8,
									},

									'.MuiLineElement-root': {
										strokeWidth: 1.5,
										boxShadow: '0px 6px 9px 0px #7CA6BD66',
									},

									'.MuiMarkElement-root': {
										r: 4,
										fill: '#ffffff',
										stroke: '#7CA6BD',
										strokeWidth: 1,
									},
								}}
							/>

							{/* ✅ Custom Legend */}
							<Stack
								direction="row"
								alignItems="center"
								spacing={1}
								justifyContent="center"
								mb={1.5}
							>
								<img
									src="/images/forecast-label.svg"
									alt=""
									style={{
										width: '16px',
										height: '16px',
										objectFit: 'contain',
									}}
								/>
								<Typography
									sx={{
										fontSize: '12px',
										fontWeight: 400,
										color: '#313131',
									}}
								>
									2020
								</Typography>
							</Stack>
						</Box>
					</Box>
				</BudgetCard>
			</div>
			<div
				style={{
					margin: '1rem 0',
				}}
			>
				<WeddingCard
					heading="Spending Forecast"
					actionLabel="View All Tasks"
				>
					<Typography variant="h5">card body...</Typography>
				</WeddingCard>
			</div>
		</div>
	)
}
